/* RESPONSIBLE TEAM: team-rd-services */

import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { request } from 'embercom/lib/inbox/requests';
import type Session from 'embercom/services/session';

export interface Monitor {
  id: string;
  name: string;
  flagCriteria: string | null;
  status: 'live' | 'disabled';
  archived: boolean;
  createdAt: string;
  updatedAt: string;
  appId: string;
  segmentIds?: number[] | null;
}

export default class MonitorsApi extends Service {
  @service declare session: Session;

  @tracked monitors: Monitor[] = [];
  @tracked isLoading = false;

  async fetchMonitors(): Promise<Monitor[]> {
    this.isLoading = true;

    try {
      let response = await request(`/teammate_app/qa/monitors?app_id=${this.session.workspace.id}`);
      let json = await response.json();
      this.monitors = json.monitors ?? [];
      return this.monitors;
    } catch (error) {
      console.error('Failed to fetch monitors:', error);
      return [];
    } finally {
      this.isLoading = false;
    }
  }

  async getMonitorById(id: string): Promise<Monitor | undefined> {
    if (this.monitors.length === 0) {
      await this.fetchMonitors();
    }
    return this.monitors.find((m) => m.id === id);
  }
}

declare module '@ember/service' {
  interface Registry {
    'monitors-api': MonitorsApi;
  }
}
